function findOccurance(pixels, query) {
    /**
     * this function accepts an array of object and returns a new object containing 
    1. with the multiple query as the key and the occurance as the value
    2. an array of all the keys (date, country, etc)
    3. An array of all the values (occurance)
     */
    let pixelsArrObjs = []
    for (let x = 0; x < pixels.length; x++) {
        let counter = 0; let obj = {};
        for (let j = 0; j < pixels.length; j++) {
            if (pixels[x][query] === pixels[j][query]) {
                if (arrayContainsKey(pixelsArrObjs, pixels[x][query]))
                    continue
                else
                    counter++
                obj[(pixels[x][query]).toString()] = counter
            }
        }
        if (Object.keys(obj).length > 0)
            pixelsArrObjs.push(obj)
        obj = {}
    }
    // get all the keys and values
    const occurances = getAllValuesFromArray(pixelsArrObjs)
    const queries = getAllKeysFromArray(pixelsArrObjs)


    return { obj: pixelsArrObjs, keys: queries, values: occurances }
}

function arrayContainsKey(arr, keyToCheck) {
    for (const obj of arr) {
        if (obj.hasOwnProperty(keyToCheck)) {
            return true;
        }
    }
    return false;
}

function getAllKeysFromArray(arr) {
    const allKeys = [];

    arr.forEach((obj) => {
        const keys = Object.keys(obj);
        allKeys.push(...keys);
    });

    allKeys.forEach((val, index) => {
        allKeys[index] = (val.toString().substring(0, 6)).replaceAll("-", " ")
    })

    return allKeys;
}

function getAllValuesFromArray(arr) {
    const allValues = [];

    arr.forEach((obj) => {
        const values = Object.values(obj);
        allValues.push(...values);
    });

    return allValues;
}

function getRandomColor() {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    let color = `#${red.toString(16)}${green.toString(16)}${blue.toString(16)}`
    if (color !== '#ffffff' || color !== '#000000')
        return color
    else
        getRandomColor()

}

const formatNumber = (num) => {
    num = parseFloat(num)
    num = num.toLocaleString()
    let commas = num.split(",")
    if (commas.length === 1) {
        // under 1000
        return num
    } else if (commas.length === 2) {
        // between 1000 to 999,999
        //convert comma to period and take only first 4 characters
        num = num.replace(",", ".")
        return num.toString().substring(0, 4) + "K"
    } else {
        // handle 1M - 999M
        num = num.replaceAll(",", ".")
        return num.toString().substring(0, 4) + "M"
    }
}

const generateIteration = (num) => {
    let arr = []
    for (let x = 0; x < num; x++)
        arr.push(x)
    return arr
}


const matchPath = (path) => {
    let pathname = window.location.pathname;
    pathname = pathname.split("/")
    pathname = pathname[pathname.length - 1]
    return path.toLowerCase() === pathname.toLowerCase()
}

const getUsername = () => {
    let pathname = window.location.pathname
    let username = pathname.split('/')[1]
    return username
}

const getTimeframe = (timestamp) => {
    const now = Date.now()
    timestamp = parseInt(timestamp)

    // get the difference between now and timestamp and divide by 1000 to get value in seconds
    let seconds = (now - timestamp) / 1000

    if (seconds < 60) {
        return Math.floor(seconds) + 's ago'
    }

    // get minutes
    let minutes = seconds / 60

    if (minutes < 60) {
        return Math.floor(minutes) + 'm ago'
    }

    // get hours
    let hours = minutes / 60

    if (hours < 24)
        return Math.floor(hours) + 'h ago'

    // get days
    let days = hours / 24

    if (days < 10) {
        let res = Math.floor(days)
        if (res === 1)
            return res + ' day ago'
        else
            return res + ' days ago'
    }

    return (new Date(timestamp)).toString().substring(4, 10)
}


const completedTrafficDataWithDate = (traffic) => {
    traffic = traffic.sort((a, b) => b.timestamp - a.timestamp)

    // filter traffic generated last in the last 7 days
    const sevenDaysAgo = Date.now() - (7 * 24 * 60 * 60 * 1000)

    const filteredTraffic = traffic.filter(t => t.timestamp > sevenDaysAgo)

    // sort array from latest to oldest
    filteredTraffic.sort((a, b) => b.timestamp - a.timestamp)

    // loop through filtered traffic and add date string 
    for (let i in filteredTraffic) {
        let date = (new Date(filteredTraffic[i].timestamp)).toString().substring(4, 10)
        // add to respective object
        filteredTraffic[i]['date'] = date
    }

    const keys = findOccurance(filteredTraffic, 'date').keys
    const values = findOccurance(filteredTraffic, 'date').values

    return { keys, values }

}

/**
 * Smart Savings Estimator
 * - High months: fixed at 24
 * - Low months: dynamic, aimed at <= $250/mo, clamped to 25..48
 * - Tiers declared within (settlement & fee rates)
 *
 * @param {number} debtAmount
 * @returns {{
 *   lowMonths: number,
 *   lowMonthly: number,
 *   highMonths: number,
 *   highMonthly: number,
 *   totalCost: number,
 *   estimatedSaving: number,
 *   debtAmount: number
 * }}
 */
function computeDebtPlan(debtAmount) {
    const D = Number(debtAmount) || 0;
    if (D <= 0) {
        return {
            lowMonths: 0,
            lowMonthly: 0,
            highMonths: 0,
            highMonthly: 0,
            totalCost: 0,
            estimatedSaving: 0,
            debtAmount: debtAmount
        };
    }

    // --- Tier selection (inside the function) ---
    // Adjust thresholds/rates if your brief differs.
    function getTierRates(amount) {
        // rs = settlement rate, rf = fee rate
        if (amount < 10000) return { rs: 0.40, rf: 0.20, tier: 'tier 1' }; // Tier 1: ~$5k–$10k
        if (amount < 20000) return { rs: 0.40, rf: 0.20, tier: 'tier 2' }; // Tier 2: $10k–$20k
        if (amount < 30000) return { rs: 0.40, rf: 0.15, tier: 'tier 3' }; // Tier 3: $20k–$30k
        return { rs: 0.35, rf: 0.15, tier: 'tier 4' };                       // Tier 4: $30k+

        // if (amount < 10000) return { rs: 0.40, rf: 0.20, tier: 'tier 1' }; // Tier 1: ~$5k–$10k
        // if (amount < 20000) return { rs: 0.40, rf: 0.20, tier: 'tier 2' }; // Tier 2: $10k–$20k
        // if (amount < 40000) return { rs: 0.40, rf: 0.15, tier: 'tier 3' }; // Tier 3: $20k–$40k
        // return { rs: 0.35, rf: 0.15, tier: 'tier 4' };                       // Tier 4: $40k+
    }

    const { rs, rf, tier } = getTierRates(D);

    // --- Core math ---
    const settlement = D * rs;
    const fee = D * rf;
    const totalCostRaw = settlement + fee;

    const toCents = n => Math.round(n * 100) / 100;

    // High plan (fixed 24 months)
    const HIGH_MONTHS = 24;
    const highMonthly = totalCostRaw / HIGH_MONTHS;

    // Low plan: dynamic months aimed at <= $250/mo, but >24 and <=48
    const TARGET = 250;
    const MIN_LOW = 24; // strictly greater than 24 per your requirement
    const MAX_LOW = 48;

    const M_star = totalCostRaw / TARGET
    let lowMonths = MAX_LOW
    //   const lowMonths = Math.min(Math.max(M_star, MIN_LOW), MAX_LOW);
    if (totalCostRaw / lowMonths < 250)
        lowMonths = M_star > MIN_LOW ? M_star : MIN_LOW;
    const lowMonthly = totalCostRaw / lowMonths;

    const totalCost = toCents(totalCostRaw);
    return {
        lowMonths: Math.ceil(lowMonths),
        lowMonthly: toCents(lowMonthly),
        highMonths: HIGH_MONTHS,
        highMonthly: toCents(highMonthly),
        totalCost,
        tier: tier,
        estimatedSaving: toCents(D - totalCost),
        debtAmount: debtAmount
    };
}


const algorithms = { findOccurance, getRandomColor, formatNumber, generateIteration, matchPath, getUsername, getTimeframe, completedTrafficDataWithDate, computeDebtPlan }

export default algorithms